// extracted by mini-css-extract-plugin
export default {"storyDetailList":"c-r_he"};